import dynamic from "next/dynamic";
import { PromotionBanner as PromotionBannerUI } from "@business-finland/wif-ui-lib/dist/PromotionBanner";

import { Viewport } from "../../../constants/app";
import useImageDataHandler from "../../../hooks/useImageDataHandler";
import { IPromotionBannerProps } from "../../../types/wif-promotion-banner";

const HtmlParser = dynamic(() => import("../../../components/HtmlParser"));

export function PromotionBanner(props: IPromotionBannerProps): JSX.Element {
  const {
    field,
    leadText,
    heading,
    bodyText,
    image,
    imageAlt,
    btnText,
    direction,
    showSaveButton,
    bgGray,
    isExternalLink,
    linkHref,
  } = props;

  const imageDataHandler = useImageDataHandler();
  const imageData = imageDataHandler(image, { maxViewport: Viewport.sm });

  const credits =
    typeof image === "string" ? "" : image?.metadata?.rights ?? "";
  const imageAltResolved =
    imageAlt ||
    (typeof image === "object" && image?.metadata?.title) ||
    "Promotion banner image";

  return (
    <PromotionBannerUI
      imageData={{ ...imageData, imageSrc: imageData.src }}
      leadText={leadText}
      heading={heading}
      body={<HtmlParser html={bodyText} />}
      promotionType={field}
      direction={direction}
      showSaveButton={showSaveButton}
      btnText={btnText}
      imageAlt={imageAltResolved}
      link={linkHref}
      isExternalLink={isExternalLink}
      backgroundColor={bgGray ? "gray" : "white"}
      credits={credits}
    />
  );
}
